import React from 'react';

export const ChevronRightIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-chevron-right"
      style={props.style || { color: '#757575', transform: 'scale(0.7)' }}
      id="right-icon"
    />
  );
};
